import Api from 'api/api';

class PaymentApi {
    getPaymentType(orderId) {
        return Api.post('/payments/types', { orderId });
    }
}

export default new PaymentApi();
